import React from 'react';

import { connect } from 'react-redux';

import { FormattedMessage } from 'react-intl';

import { openSearch } from 'depop/state/navigation';

const SearchLink = ({ openSearch, ...props }) =>
  <a onClick={openSearch} {...props}>
    <FormattedMessage
      id="app.searchLabel"
      description="Search Label"
      defaultMessage="Search"
    />
  </a>;

const mapDispatchToProps = dispatch => {
  return {
    openSearch: () => dispatch(openSearch()),
  };
};

export default connect(null, mapDispatchToProps)(SearchLink);



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/SearchLink.js